import React from "react";
import WithDrawalCard from "../WithDrawalCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlusSquare,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { Image } from "react-bootstrap";
import { get } from "lodash";
import { ssnMasking } from "../../utils";
import GetInitials from "../GetInitials";

const HeadingAndTextComponent = ({
  headingText = "",
  contentText = "",
  style = { marginLeft: "50px" },
  filteredValues,
}) => (
  <div style={{ ...style }}>
    <div className="textHeading">{headingText}</div>
    <div className="textWord mt-2" style={{ paddingTop: "4px" }}>
      {contentText}
    </div>
  </div>
);

function EmployeeDetailsCard({
  style = 1,
  children,
  setMoreInfoSlideOpen,
  filteredValues,
}) {
  return (
    <>
      <WithDrawalCard>
        <div>
          {/* <Image
            style={{
              width: "80px",
              height: "80px",
              marginLeft: "20px",
            }}
            src="https://media.geeksforgeeks.org/wp-content/uploads/20210425000233/test-300x297.png"
            roundedCircle
          /> */}
          <div style={{ borderRadius: "50%", overflow: "hidden" }}>
            <GetInitials name={filteredValues.firstName} />
          </div>
        </div>
        <div>
          <div
            style={{
              fontWeight: 500,
              fontSize: "20px",
              marginRight: "auto",
              color: "black",
            }}
          >
            {`${get(filteredValues, "firstName", "") ?? ""} ${
              get(filteredValues, "middleName", "") ?? ""
            } ${get(filteredValues, "lastName", "") ?? ""}`}
          </div>
          <div
            style={{
              color: "#06741A",
              fontWeight: 500,
              fontSize: "18px",
              paddingTop: "5px",
            }}
          >
            {filteredValues.employmentStatus == "Active" ? (
              <div className="employee-status mt-1">
                {filteredValues.employmentStatus}{" "}
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  color=" #1C7E18"
                  size="md"
                />
              </div>
            ) : filteredValues.employmentStatus == "Terminated" ? (
              <div className="employee-status-danger mt-1">
                {filteredValues.employmentStatus}{" "}
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color="#DE2323"
                  size="md"
                />
              </div>
            ) : (
              filteredValues.employmentStatus
            )}
          </div>
        </div>
        <HeadingAndTextComponent
          headingText="Employee ID"
          contentText={filteredValues.employeeNumber}
        />
        <HeadingAndTextComponent
          headingText="SSN"
          contentText={ssnMasking(
            get(filteredValues, "uniquePersonalIdentification", "")
          )}
        />
        <HeadingAndTextComponent
          style={{ marginRight: "100px", marginLeft: "50px" }}
          headingText="Company Name"
          contentText={get(filteredValues, "companyName", "")}
        />
        <div
          className="textHeading primary-small"
          style={{ fontSize: "14px", cursor: "pointer" }}
          onClick={() => setMoreInfoSlideOpen(true)}
        >
          View More
        </div>
      </WithDrawalCard>
    </>
  );
}

export default EmployeeDetailsCard;
